/* lua.js generated code 0.3.0 */
 //- create some filters to build a FilteredSprite
// @author zrong(zengrong.net)
// Creation 2014-03-31
//------------------------------
// @module filter
/* --

滤镜功能

 */
var filter = {}
// var FILTERS = table(
//     [1, "GRAY", table([0, cc.GrayFilter])],
//     [1, "RGB", table(
//         [0, cc.RGBFilter],
//         3,
//         [0, table(
//             1,
//             1,
//             1
//         )]
//     )],
//     [1, "HUE", table(
//         [0, cc.HueFilter],
//         1,
//         [0, table(0)]
//     )],
//     [1, "BRIGHTNESS", table(
//         [0, cc.BrightnessFilter],
//         1,
//         [0, table(0)]
//     )],
//     [1, "SATURATION", table(
//         [0, cc.SaturationFilter],
//         1,
//         [0, table(1)]
//     )],
//     [1, "CONTRAST", table(
//         [0, cc.ContrastFilter],
//         1,
//         [0, table(1)]
//     )],
//     [1, "EXPOSURE", table(
//         [0, cc.ExposureFilter],
//         1,
//         [0, table(0)]
//     )],
//     [1, "GAMMA", table(
//         [0, cc.GammaFilter],
//         1,
//         [0, table(1)]
//     )],
//     [1, "HAZE", table(
//         [0, cc.HazeFilter],
//         2,
//         [0, table(0, 0)]
//     )],
//     [1, "SEPIA", table([0, cc.SepiaFilter])],
//     [1, "GAUSSIAN_VBLUR", table(
//         [0, cc.GaussianVBlurFilter],
//         1,
//         [0, table(0)]
//     )],
//     [1, "GAUSSIAN_HBLUR", table(
//         [0, cc.GaussianHBlurFilter],
//         1,
//         [0, table(0)]
//     )],
//     [1, "ZOOM_BLUR", table(
//         [0, cc.ZoomBlurFilter],
//         3,
//         [0, table(
//             1,
//             0.5,
//             0.5
//         )]
//     )],
//     [1, "MOTION_BLUR", table(
//         [0, cc.MotionBlurFilter],
//         2,
//         [0, table(1, 0)]
//     )],
//     [1, "STROKE", table([0, cc.StrokeFilter])],
//     [1, "SHARPEN", table(
//         [0, cc.SharpenFilter],
//         2,
//         [0, table(0, 0)]
//     )],
//     [1, "MASK", table([0, cc.MaskFilter], 1)],
//     [1, "DROP_SHADOW", table([0, cc.DropShadowFilter], 3)],
//     [1, "CIRCLE_CROP", table(
//         [0, cc.CircleCropFilter],
//         2,
//         [0, table([0, cc.p(0.5, 0.5)], 0.5)]
//     )],
//     [1, "CUSTOM", table([0, cc.CustomFilter], 1)]
// )
// var MULTI_FILTERS = table([1, "GAUSSIAN_BLUR", table()])
filter.newFilter = function (__filterName, __param) {
    return null
    var __filterData = FILTERS[__filterName]
    assert(__filterData, "filter.newFilter() - filter " + __filterName + " is not found.")
    var [__cls, __count, __default] = unpack(__filterData)
    if ("CUSTOM" === __filterName) {
        // WARN: maybe multi result
        return __cls.create(__param)
    }
    var __paramCount = (__param && $len(__param)) || 0
    if (__count == null) {
        if (__paramCount === 0) {
            // WARN: maybe multi result
            return __cls.create()
        }
    } else if (__count === 0) {
        // WARN: maybe multi result
        return __cls.create()
    } else {
        if (__paramCount === 0) {
            // WARN: maybe multi result
            return __cls.create(...unpack(__default))
        }
        assert(__paramCount === __count, string.format("filter.newFilter() - the parameters have a wrong amount! Expect %d, get %d.", __count, __paramCount))
    }
    // WARN: maybe multi result
    if (__cls == null){
        return {setFilters:function() {} };
    }

    return __cls.create(...unpack(__param))
}
// start --
//------------------------------
// 创建滤镜数组，并返回 Filter 的数组对象
// @function [parent=#filter] newFilters
// @param table __filterNames 滤镜名称数组
// @param table __params 对应参数数组
// @return table#table ret (return value: table)   Filter数组
// end --
filter.newFilters = function (__filterNames, __params) {
    return null
    assert($len(__filterNames) === $len(__params), "filter.newFilters() - Please ensure the filters and the parameters have the same amount.")
    var __filters = table()
    for (var i = 1, $t11 = __filterNames[1]; $t11; i++, $t11 = __filterNames[i]) {
        table.insert(__filters, filter.newFilter(__filterNames[i], __params[i]))
    }
    return __filters
}
module.exports = filter
